import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ui-label-text',
  templateUrl: './ui-label-text.component.html',
  styleUrl: './ui-label-text.component.scss',
  standalone: false,
})
export class UiLabelTextComponent {
  @Input() label: string;
  @Input() text: any;
}
